var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-radio-group',{attrs:{"hide-details":"","value":_vm.selectedRadio},on:{"change":function($event){return _vm.$emit('radio-selected', $event)}}},_vm._l((_vm.radioCount),function(n){return _c('v-radio',{key:n,class:{
      'bb-radio': true,
      'bb-radio--disabled': _vm.disabled[n - 1],
      'bb-radio--dark': _vm.dark
    },attrs:{"value":n,"disabled":_vm.disabled[n - 1],"dark":_vm.dark},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"bb-radio-label"},[_vm._v(_vm._s(_vm.labels[n - 1]))])]},proxy:true}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }